import React, { useState } from "react";
import {
  clearResponseMessageAfterDelay,
  errorMessage,
  successMessage,
} from "../../redux/slices/responseMessage.slice";
import { useDispatch, useSelector } from "react-redux";
import AppService from "../../services/appServices";
import ReUse from "../../services/helpers/reUse";
import { Rating } from "react-simple-star-rating";
import CustomButton from "../../Components/ReUse/Components/Button";
import ResponseMessage from "../../Components/ReUse/ResponseMessage";
import swal from "sweetalert";

const ReveiwForm = ({ propsData }) => {
  const dispatch = useDispatch();

  const { sellerId } = propsData ?? {};

  const [reveiwLoader, setReveiwLoader] = useState(false);
  const [givenRating, setGivenRating] = useState(null);
  const [loading, setLoading] = useState(false);

  const [allErrors, setAllErrors] = useState({
    name: "",
    email: "",
    comment: "",
  });
  const [fieldsData, setFieldsData] = useState({
    name: "",
    email: "",
    comment: "",
  });

  const isLoginAuth = useSelector(
    (state) => state.persistedReducer.auth.authenticated
  );

  // const reveiwSubmitHandler = async (e) => {
  //   e.preventDefault();
  //   setReveiwLoader(true);

  //   if (!isLoginAuth) {
  //     dispatch(errorMessage("Please Login For Review"));
  //     dispatch(clearResponseMessageAfterDelay());
  //     setReveiwLoader(false);
  //     return;
  //   }

  //   if (!givenRating) {
  //     setReveiwLoader(false);
  //     dispatch(errorMessage("Add Rating"));
  //     dispatch(clearResponseMessageAfterDelay());
  //     return;
  //   }

  //   try {
  //     const { name, email, comment } = fieldsData;

  //     // const fields = { name, email, comment };
  //     // const allErrors = ReUse.validateRequired({ fields: fields });

  //     // // Check if there are any errors
  //     // if (Object.keys(allErrors).length > 0) {
  //     //   setAllErrors(allErrors);
  //     //   setReveiwLoader(false);
  //     //   return;
  //     // }

  //     const payload = {
  //       // name: name,
  //       // email: email,
  //       description: comment,
  //       seller_id: sellerId,
  //       rating: givenRating,
  //     };

  //     const apiResp = await AppService.storesubReviews(payload);
  //     const { message, response } = apiResp.data;
  //     // console.log(apiResp, "jujuu");
  //     // setReveiwLoader(false);
  //     swal("hello" ,"hyhyhy" ,"success")
  //     // dispatch(successMessage(message));
  //     // setTimeout(() => {
  //     //   dispatch(successMessage("Processing feedback."));
  //     //   setTimeout(() => {
  //     //     dispatch(successMessage(""));
  //     //   }, 1000);
  //     // }, 1000);
  //     ReUse.scrollToTop();
  //   } catch (err) {
  //     // setReveiwLoader(false);
  //     // dispatch(successMessage(""));
  //     // dispatch(errorMessage("Something Went Wrong"));
  //     // dispatch(clearResponseMessageAfterDelay());
  //   }
  // };

  const { name, email, comment } = fieldsData || {};
  const reveiwSubmitHandler = async (e) => {
    e.preventDefault();

    setReveiwLoader(true);

    if (!isLoginAuth) {
      swal("Sorry!", "Please Login First!", "error");
      // dispatch(errorMessage("Please Login for Review"));
      dispatch(clearResponseMessageAfterDelay());
      setReveiwLoader(false);
    }

    if (!givenRating) {
      setReveiwLoader(false);
      dispatch(errorMessage("Add Rating"));
      dispatch(clearResponseMessageAfterDelay());
      return;
    }

    // if (!reveiwFeedback) {
    //   setReveiwLoader(false);
    //   dispatch(errorMessage("Add feedback"));
    //   dispatch(clearResponseMessageAfterDelay());

    //   return;
    // }

    try {
      const payload = {
        // product_id: product_id,
        // comment: reveiwFeedback,
        // rating: givenRating,
        description: comment,
        seller_id: sellerId,
        rating: givenRating,
      };
      console.log(payload, "dakieu83");

      const apiResp = await AppService.storesubReviews(payload);
      const { message, response } = apiResp.data;
      swal({
        title: "Thank You",
        text: "Your Review Has been Submitted.",
        timer: 2000,
      });
      setReveiwLoader(false);
      // dispatch(successMessage(message));
      // setTimeout(() => {
      //   dispatch(successMessage("Processing feedback."));
      //   setTimeout(() => {
      //     dispatch(successMessage(""));
      //   }, 1000);
      // }, 1000);
    } catch (err) {
      setReveiwLoader(false);
      // dispatch(successMessage(""));
      // dispatch(errorMessage("Something Went Wrong"));
      // dispatch(clearResponseMessageAfterDelay());
    }
  };
  console.log(fieldsData, "hihihi");
  const handleRating = (rating) => {
    setGivenRating(rating);
  };

  function handleChange(e) {
    const resetErrors = ReUse.resetErrors({ fields: allErrors });
    setAllErrors(resetErrors);
    const { value, name } = e.target;
    setFieldsData({
      ...fieldsData,
      [name]: value,
    });
  }

  const currentUser = useSelector((state) => state.persistedReducer.auth.user);

  return (
    <>
      <div className="seller-review-form-sec">
        <div className="row">
          <div className="col-md-12">
            <div className="all-review-form">
              <form>
                <div className="review-head">
                  <h3>Review</h3>
                  <p>Add a review</p>
                  <p>
                    Your email address will not be published. Required fields
                    are marked *
                  </p>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="review-form-input">
                      <input
                        type="text"
                        placeholder="Name"
                        name="name"
                        onChange={handleChange}
                        disabled={true}
                        // value={name}
                        value={currentUser?.first_name}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="review-form-input">
                      <input
                        type="text"
                        placeholder="Email"
                        name="email"
                        onChange={handleChange}
                        disabled={true}
                        // value={email}
                        value={currentUser?.email}
                      />
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="review-form-input">
                      <textarea
                        class="form-control"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        placeholder="Comment"
                        name="comment"
                        onChange={handleChange}
                        value={comment}
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="review-rating-star">
                      <h4>Ratings</h4>
                      <Rating
                        size={20}
                        allowFraction={true}
                        readonly={false}
                        onClick={handleRating}
                        className="mb-3"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="review-send">
                      {/* <CustomButton
                        loading={reveiwLoader}
                        onClickHandler={reveiwSubmitHandler}
                        customClassName="custom-btn"
                      >
                        Submit
                      </CustomButton>
                       */}
                      <button
                        loading={reveiwLoader}
                        onClick={(e) => reveiwSubmitHandler(e)}
                      >
                        sumbit boy
                      </button>

                      <ResponseMessage />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReveiwForm;
